import React, { useEffect, useRef } from 'react';
import { Col, Card } from "react-bootstrap";
import GenderAgeBarChart from "./GenderAgeBarChart";
import { useDonor } from '../../../../../context/donor/donor.context';
import { useTranslation } from "react-i18next";
const DonorsGenderAgeChart = () => {
    const { 
        genderAgeStatistics, 
        fetchDonorsGenderAgeStatistics, 
        loading 
    } = useDonor();
    const { t } = useTranslation();
    const hasFetchedRef = useRef(false);
    
    useEffect(() => {
        if (!hasFetchedRef.current) {
            console.log("Fetching gender-age statistics..."); // ✅ Debug
            fetchDonorsGenderAgeStatistics();
            hasFetchedRef.current = true;
        }
    }, []);

    // ✅ Add this to debug
    useEffect(() => {
        console.log("Current genderAgeStatistics:", genderAgeStatistics);
        console.log("Current loading:", loading);
    }, [genderAgeStatistics, loading]);

    const handleRefresh = () => {
        fetchDonorsGenderAgeStatistics();
    };

    return (
        <Col xl={12} lg={12}>
            <Card>
                <Card.Header className="d-flex justify-content-between align-items-center">
                    <Card.Title>{t("genderDistributionByAgeRange")}</Card.Title>
                    <button 
                        className="btn btn-sm btn-primary" 
                        onClick={handleRefresh}
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-1" role="status"></span>
                                {t("Loading")}...
                            </>
                        ) : (
                            <>
                                <svg 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    width="16" 
                                    height="16" 
                                    fill="currentColor" 
                                    className="me-1" 
                                    viewBox="0 0 16 16"
                                >
                                    <path fillRule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                                    <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
                                </svg>
                            </>
                        )}
                    </button>
                </Card.Header>
                <Card.Body>
                    {/* ✅ Show loading state */}
                    {loading && !genderAgeStatistics ? (
                        <div className="text-center py-5">
                            <div className="spinner-border" role="status">
                                <span className="sr-only"> {t("Loading")}......</span>
                            </div>
                        </div>
                    ) : genderAgeStatistics && genderAgeStatistics.total > 0 ? (
                        <>
                            <GenderAgeBarChart genderAgeStatistics={genderAgeStatistics} />
                            <div className="mt-3 text-center">
                                <div className="row">
                                    <div className="col-md-4">
                                        <strong> {t("donors.totalDonors")}</strong> {genderAgeStatistics.total}
                                    </div>
                                    <div className="col-md-4">
                                        <span style={{ color: '#3b4cb8' }}>● </span>
                                        <strong>{t("donors.totalMale")}:</strong> {genderAgeStatistics.totalMale}
                                    </div>
                                    <div className="col-md-4">
                                        <span style={{ color: 'rgba(89, 59, 219, 0.7)' }}>● </span>
                                        <strong>{t("donors.totalFemale")}:</strong> {genderAgeStatistics.totalFemale}
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-12">
                                        <p className="text-muted">
                                            {t("Age Distribution")}
                                            18-25 ({genderAgeStatistics.maleData[0]}M / {genderAgeStatistics.femaleData[0]}F) | 
                                            25-35 ({genderAgeStatistics.maleData[1]}M / {genderAgeStatistics.femaleData[1]}F) | 
                                            35-45 ({genderAgeStatistics.maleData[2]}M / {genderAgeStatistics.femaleData[2]}F) | 
                                            45+ ({genderAgeStatistics.maleData[3]}M / {genderAgeStatistics.femaleData[3]}F)
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : (
                        <div className="text-center py-5">
                            <p>{t("No data available")}</p>
                        </div>
                    )}
                </Card.Body>
            </Card>
        </Col>
    )
}

export default DonorsGenderAgeChart;